<template>
  <div class="flex-col w-full p-5">
    <!-- Error Messages Section -->
    <div
      v-if="filteredErrors.length"
      class="mb-4 p-3 bg-red-100 text-red-700 rounded"
    >
      <ul class="list-disc list-inside">
        <li v-for="(error, index) in filteredErrors" :key="index">
          {{ error }}
        </li>
      </ul>
    </div>

    <div class="grid grid-cols-2 gap-4 w-full mx-auto">
      <input
        type="text"
        placeholder="نام"
        class="input w-full font-normal"
        v-model="name"
      />

      <input
        type="email"
        placeholder="آدرس ایمیل"
        class="input w-full font-normal"
        v-model="email"
      />

      <input
        type="text"
        placeholder="شماره تلفن"
        class="input w-full font-normal"
        v-model="phone"
      />

      <input
        type="text"
        placeholder="شغل"
        class="input w-full font-normal"
        v-model="occupation"
      />

      <input
        type="text"
        placeholder="آدرس"
        class="col-span-2 w-full font-normal input"
        v-model="location"
      />
    </div>

    <div class="flex gap-2 mt-10 justify-end">
      <button
        @click="closeModal"
        class="text-stone-500 rounded-lg border border-transparent transition-all active:border-black py-2 px-4"
      >
        بستن
      </button>
      <button
        @click="handleSubmit"
        class="bg-green-500 text-white rounded-lg py-2 px-4 transition-colors hover:bg-green-600 disabled:bg-gray-400 disabled:cursor-not-allowed flex items-center justify-center"
        :disabled="isPending"
      >
        افزودن مخاطب
      </button>
    </div>
  </div>
</template>

<script setup>
import { updateContact } from "@/services/api/apiServiceContacts";
import { useMutation } from "@tanstack/vue-query";
import Swal from "sweetalert2";
import { defineEmits, ref, computed } from "vue";
import { useStore } from "vuex";

const store = useStore();
const emit = defineEmits(["close"]);

const selectedContact = computed(
  () => store.getters["contactsSlice/selectedContact"]
);

const name = ref(selectedContact.value.name);
const email = ref(selectedContact.value.email);
const phone = ref(selectedContact.value.phone);
const occupation = ref(selectedContact.value.occupation);
const location = ref(selectedContact.value.location);

const errors = ref({
  name: "",
  email: "",
  phone: "",
  occupation: "",
  location: "",
});

// Computed property to filter non-empty errors
const filteredErrors = computed(() => {
  return Object.values(errors.value).filter((error) => error);
});

// Validation function
function validateForm() {
  let isValid = true;
  errors.value = {
    name: "",
    email: "",
    phone: "",
    occupation: "",
    location: "",
  };

  if (!name.value.trim()) {
    errors.value.name = "نام اجباری است.";
    isValid = false;
  }
  if (!email.value.trim() || !/\S+@\S+\.\S+/.test(email.value)) {
    errors.value.email = "آدرس ایمیل معتبر نیست.";
    isValid = false;
  }
  if (!phone.value.trim()) {
    errors.value.phone = "شماره تلفن اجباری است.";
    isValid = false;
  }
  if (!occupation.value.trim()) {
    errors.value.occupation = "شغل اجباری است.";
    isValid = false;
  }
  if (!location.value.trim()) {
    errors.value.location = "آدرس اجباری است.";
    isValid = false;
  }

  return isValid;
}

// Handle form submission
const { mutate, isPending } = useMutation({
  mutationKey: ["postContact"],
  mutationFn: updateContact,
  onSuccess: () => {
    store.dispatch("contactsSlice/getContacts");
    Swal.fire({
      icon: "success",
      title: "مخاطب با موفقیت ویرایش شد.",
      showConfirmButton: false,
      timer: 1500,
    });
    closeModal();
  },
  onError: (err) => {
    Swal.fire({
      icon: "error",
      title: "ویرایش مخاطب با خطا مواجه شد!",
      showConfirmButton: false,
      timer: 1500,
    });
    console.error(err);
  },
});

function handleSubmit() {
  if (!validateForm()) return;

  const id = selectedContact.value.id;

  const updatedData = {
    id,
    name: name.value,
    phone: phone.value,
    email: email.value,
    occupation: occupation.value,
    location: location.value,
    leads: 0,
  };

  mutate({ contactId: id, payload: updatedData });
}

function closeModal() {
  emit("close");
}
</script>
